export const safeDispatch = event => global?.dataLayer?.push?.(event);

export default {
  sendOpenModalEvent: areaIds =>
    safeDispatch({
      event: "custom_event",
      event_category: "search",
      event_action: "click",
      event_label: `area:${areaIds.toString()}`
    }),
  sendResetEvent: areaIds =>
    safeDispatch({
      event: "custom_event",
      event_category: "search",
      event_action: "reset",
      event_label: `area:${areaIds.toString()}`
    }),
  sendDoneEvent: areaIds =>
    safeDispatch({
      event: "custom_event",
      event_category: "search",
      event_action: "done",
      event_label: `area:${areaIds.toString()}`
    }),
  sendCloseButtonClickEvent: areaIds =>
    safeDispatch({
      event: "custom_event",
      event_category: "search",
      event_action: "exit",
      event_label: `area:${areaIds.toString()}|type=click_close`
    }),
  sendViewMapEvent: () =>
    safeDispatch({
      event: "custom_event",
      event_category: "search",
      event_action: "click",
      event_label: "view_map"
    }),
  sendOverlayClickEvent: areaIds =>
    safeDispatch({
      event: "custom_event",
      event_category: "search",
      event_action: "exit",
      event_label: `area:${areaIds.toString()}|type=click_space`
    })
};
